import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  root:{
    padding: "20px 0 0 0",
    position: 'relative',
    left: "10px",
    top: "-5px",

  },
  title: {
    color: "white",
    position: "relative",
    top: "-17px",
    fontSize: "38px !important",
    fontWeight: 600,
  },
  headerWrapper: {
    backgroundPosition: "top center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "contain",
    background: `radial-gradient(6.98% 38.82% at 52.05% 56.58%, #425F4F 5.56%, #1D321A 100%)`,
    width: "100%",
    height: "160px",
    position: "relative",
    top: "-1rem",
    borderRadius: "0 0 12px 12px",
    paddingTop: ".5rem",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  headerContent: {
    position: "relative",
    bottom: "10px",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
  },
  mainContentWrapper:{
    position: "relative",
    top: "-3.5rem",
  },
  headerLogo: {
    position: 'absolute',
    left: "calc(50% - 100px)"
  },
  // Tab
  tab: {
    fontWeight: 600,
    borderRadius: '18px 18px 0 0',
    minWidth: "38px",
    height: "25px",
    marginRight: "2px",
    backgroundColor: "white",
    zIndex: 1,
    textTransform: "none",
  },
  selectedTab: {
    color: "black !important",
  },
  unselectedTab: {
    opacity: .75,
  },
  tabsWrapper: {
    border: "none",
    borderBottom: 1,
    borderColor: 'divider',
  },
  tabContentWrapper: {
    backgroundColor: theme.palette.background.white,
    borderRadius: "0 12px 12px 12px",
  },
  backToHome: {
    cursor: "pointer",
    color: theme.palette.primary.primary100,
    fontWeight: 700,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: ".5rem",
    textDecoration: "none",
    marginLeft: ".5rem",
  },
  tabDisabled: {
    opacity: 0.75,
    background: "#E2E2EABF",
  },
  appBar:{
    height: "64px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    alignItems: "center",
    width: "100%",
    position: "relative",
    top: "-2px",
    borderRadius: "12px 12px 0 0",
    backgroundColor: "#1D321A",
  },
  //Roadmap
  roadmapWrapper: {
    minHeight: '250px',
    margin: '0px 20px 20px 25px',
    paddingTop: "20px",
    paddingBottom: "20px",
    display: 'flex',
    flexWrap: "wrap",
    gap: "16px",
    justifyContent: 'flex-start',
  },
  roadmapItemWrapper: {
    width: "calc(33% - (16px/2))",
    border: "1px solid #FFF",
    borderRadius: "12px",
    backgroundColor: "#FBFCF9 !important",
    height: "257px",
    boxShadow: "none",
  },
  roadmapContentWrapperWithImage: {
    height: "120px",
    marginBottom:" 8px",
  },
  roadmapContentWrapperWithoutImage: {
    overflow: "hidden",
    height: "257px",
  },
  roadmapItemTitle: {
    fontWeight: 600,
    marginBottom: "12px",
    fontSize: "18px",
  },
  roadmapItemContent: {
    fontSize: "15px",
    color: "#373534"
  },
  //Disclaimer
  disclaimerWrapper: {
    color: "#535362",
    fontWeight: 600,
    fontSize: "14px",
    display: "flex",
    gap: "14px",
    padding: "20px 20px 0px 35px"
  },
  readMore: {
    color: theme.palette.primary.main,
  },
  //Pop up
  mainContentPopUpWrapper: {
    backgroundColor: "#F9F9FB",
    margin: "-15px -20px -20px -20px",
    padding: "20px",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    gap: "30px",
    color: "#373534",
    fontSize: "14px",
    lineHeight: "140%",
  },
  illustration: {
    maxWidth: "100%"
  },
}));

export default useStyles;
